import {List} from 'immutable';

export const isDeepEqual = (x: any, y: any) => {
  if (x === y) {
    return true;
  } else if (typeof x === 'object' && x !== null && typeof y === 'object' && y !== null) {
    if (List.isList(x) && List.isList(y)) {
      x = x.toArray();
      y = y.toArray();
    }

    if (Object.keys(x).length !== Object.keys(y).length) {
      return false;
    }

    for (const prop in x) {
      if (y.hasOwnProperty(prop)) {
        if (!isDeepEqual(x[prop], y[prop])) {
          return false;
        }
      } else {
        return false;
      }
    }

    return true;
  } else {
    return false;
  }
};
